import { RowContentPage } from '@mb.io/core-components';

export const ContentTab = () => <RowContentPage />;
